<template>
  <div class="text-primary l-h-22 grey">
    <p>
      Well-planned and high-quality ISS (Integrated Summary of Safety) and ISE (Integrated Summary
      of Efficacy) are crucial for the successful regulatory submission of your Common Technical
      Document (CTD). Considering the fact that each submission can be very specific and of unique
      character, it can be a challenge to develop your integrated summaries on your own. Not to
      mention that a single failure and rejection from the FDA will cause a lot of trouble:
      an approval process that can be delayed for over a year, costly resubmission, etc.
    </p>
    <p class="pb-3">
      STATECS is here to save you the trouble. Having developed a large number of integrated
      summaries for a wide range of clients, our specialists will surely deliver you the highest
      quality results that comply with the whole regulatory process perfectly. We will provide
      you with useful advice on how to properly collect and combine data in your summaries, as
      well as how to shorten the waiting time for the FDA approval as much as possible.
    </p>
    <div class="card-ctx float-right">
      <p>
        ISS and ISE are beneficial for several reasons:
      </p>
      <ul class="ml-4">
        <li>
          Finding out atypical/unusual trends in patient subgroups
        </li>
        <li>
          Improving the accuracy of the results
        </li>
        <li>
          Risk and benefit assessment based on the comparison of variation in study
        </li>
        <li>
          Achieving a strong statistical conclusion
        </li>
      </ul>
    </div>
    <b-card-title
      class="title text-primary font-weight-bold f-s-22 l-s-0"
      style="right: 48%"
    >
      {{ modalItem.title }}
    </b-card-title>
  </div>
</template>

<script>
export default {
  name: 'IssIseServices',
  props: {
    modalItem: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
